module.exports = __webpack_public_path__ + "static/media/img5.a585407e.png";